import BinApiService from "src/api/BinApiService";
import { queryOptions } from "./v4QueryOptions/queryOptions";
import { binDBKeys } from "src/pages/binOverview/BinCommander";

export const TAPESTRIP_CATEGORY = "tapestrip";
export const cycleAveragesQueryOptions = (binId: number | null | undefined, hours: number) => queryOptions({
    queryKey: [...binDBKeys.bin(binId!), {category: TAPESTRIP_CATEGORY, purpose: "CycleAverages", durationSeconds: hours * 3600}] as const,
    queryFn: async (q) => await BinApiService.getPremierPlusCycleAverages(q.queryKey[1], q.queryKey[2]?.durationSeconds, q.signal),
    enabled: (binId ?? 0) > 0,
});